import { Wrapper } from '@googlemaps/react-wrapper';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import { Config } from '../config';
import { store } from '../store';
import AppContainer from './AppContainer';
import { queryClient } from './queryClient';

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

const render = () => {
  return <div />;
};

window.addEventListener('resize', appHeight);
appHeight();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={4}
        />
        <Wrapper apiKey={Config.GoogleApiKey} render={render}>
          <AppContainer className="row centered-form center-block" />
        </Wrapper>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
